<template>
  <div id="container">
    <div class="top">
      <div class="topL">
        <img src="https://imagessl.edujia.com/A-1ed71af7_20230804162525.png" crossorigin="Anonymous" />
        <div @click="backClick">返回</div>
      </div>
      <div class="saveBtn" @click="savebtnClick">保存</div>
    </div>
    <input class="title" placeholder="标题（选填）" v-model="title" />
    <!-- <textarea class="content" placeholder="输入内容" v-model="content"  :style="{'height':contentHeight+'px'}"></textarea> -->
    <textarea ref="textarea" class="content" placeholder="输入内容" v-model="content" @blur="onBlur"></textarea>
    <div class="bottomBar">
      <div v-if="!editHuashuData" class="bottomBarL">
        <div class="optionTitle">排序：</div>
        <div class="optionItem" @click="changeFront(1)">
          <img v-if="isFront==2" src="https://imagessl.edujia.com/A-1ed71af7_20230825151642.png" />
          <img v-else src="https://imagessl.edujia.com/A-1ed71af7_20230825145228.png" />
          <div>排在最前</div>
        </div>
        <div class="optionItem optionItem2" @click="changeFront(2)">
          <img v-if="isFront==1" src="https://imagessl.edujia.com/A-1ed71af7_20230825151642.png" />
          <img v-else src="https://imagessl.edujia.com/A-1ed71af7_20230825145228.png" />
          <div>排在最后</div>
        </div>
      </div>
      <div class="bottomBarL">
        <div class="optionTitle">发送时是否带标题</div>
        <div class="optionItem" @click="()=>{this.isCarryTitle=!this.isCarryTitle}">
          <img v-if="!isCarryTitle" src="https://imagessl.edujia.com/A-1ed71af7_20230825151642.png" />
          <img v-else src="https://imagessl.edujia.com/A-1ed71af7_20230825145228.png" />
          <div>带</div>
        </div>
        <div class="optionItem optionItem2" @click="()=>{this.isCarryTitle=!this.isCarryTitle}">
          <img v-if="isCarryTitle" src="https://imagessl.edujia.com/A-1ed71af7_20230825151642.png" />
          <img v-else src="https://imagessl.edujia.com/A-1ed71af7_20230825145228.png" />
          <div>不带</div>
        </div>
      </div>
      <div class="bottomBarR">
        <div class="addLink" @click="addMediaBtnClick">
          <img src="https://imagessl.edujia.com/A-1ed71af7_20230825152336.png" />图片/视频/文件
        </div>
        <div class="addLink" @click="insertPartSimbol">插入强制分段符</div>
        <!-- <div class="saveBtn" @click="savebtnClick">保存</div> -->
      </div>
    </div>
    <div class="list">
      <div v-for="(item,idx) in fileList" class="itemP">
        <img class="itemClose" src="https://imagessl.edujia.com/A-1ed71af7_20231011175157.png" @click="delClick(idx)" />
        <img v-if="item.fileType=='img'&&item.path" class="imgItem item" :src="item.path" />
        <img v-else-if="item.fileType=='img'&&item.url" class="imgItem item" :src="item.url" />
        <div v-else-if="item.fileType=='video'" class="videoItem item">
          <img class="miniVideoIcon videoIcon" src="https://imagessl.edujia.com/A-1ed71af7_20231013134229.png">
          <img :src="item.videoInfo.poster">
        </div>
        <div v-else class="fileItem item">
          <img :src="item.icon" />
          <div v-if="item.file.name">{{item.file.name}}</div>
          <div v-else-if="item.name">{{item.name}}</div>
        </div>
        <!-- <img v-if="item.file.type.includes('image')" class="imgItem item" :src="item.path" />
                <div v-else-if="item.file.type.includes('video')" class="videoItem item">
                    <img class="miniVideoIcon videoIcon" src="https://imagessl.edujia.com/A-1ed71af7_20231013134229.png">
                    <img :src="item.videoInfo.poster">
                </div>
                <div v-else class="fileItem item" >
                   <img :src="item.icon" />
                   <div>{{item.file.name}}</div>
               </div> -->
        <div v-if="item.fileType=='img'" class="fileLabel">图片{{item.newImportIdx+1}}</div>
        <div v-else-if="item.fileType=='video'" class="fileLabel">视频{{item.newImportIdx+1}}</div>
        <div v-else-if="item.fileType=='audio'" class="fileLabel">音频{{item.newImportIdx+1}}</div>
        <div v-else class="fileLabel">文件{{item.newImportIdx+1}}</div>
        <!-- <div v-if="item.file.type.includes('image')" class="fileLabel">图片{{item.newImportIdx+1}}</div>
               <div v-else-if="item.file.type.includes('video')" class="fileLabel">视频{{item.newImportIdx+1}}</div>
               <div v-else class="fileLabel">文件{{item.newImportIdx+1}}</div> -->
        <div v-if="item.file.type.includes('video')" class="videoPoster" :id="'video'+item.newImportIdx">
          <div class="videoPosterT">
            <img class="videoIcon" src="https://imagessl.edujia.com/A-1ed71af7_20231013134229.png">
            <div class="videoItemVideo"
              :style="`background: url(`+item.videoInfo.poster+`)center center / cover no-repeat;`"></div>
            <!-- <div class="videoItemVideo" >
                            <img :src="item.videoInfo.poster">
                        </div> -->
          </div>
          <div class="videoPosterB">
            <div class="videoPosterBL" :id="'videoQr'+item.newImportIdx"></div>
            <div class="videoPosterBR">
              <div class="videoPosterBRT">扫一扫看视频</div>
              <div class="videoPosterBRB">视频时长{{$common.ts2timeDay(item.videoInfo.duration*1000)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <input v-show="false" type="file" ref="fileInput" @change="fileImport" multiple>
  </div>
</template>

<script>
  import qiniuService from "@/service/qiniuService"
  import html2canvas from 'html2canvas';
  import QRCode from 'qrcodejs2'
  import Vue from 'vue'
    import {
        Radio,
        RadioGroup
    } from 'element-ui';
    Vue.use(RadioGroup)
    Vue.use(Radio)

  export default {
    props: [],
    data() {
      return {
        pageWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        pageHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        isFront: localStorage.getItem("isFront") ? localStorage.getItem("isFront") : 1,
        title: "",
        content: "",
        speechId: this.$route.query.speechId,
        labelId: this.$route.query.labelId,
        editHuashuData: null,
        contentHeight: 0,
        huashuId: null,
        fileList: [],
        newImgCount: 0,
        newVideoCount: 0,
        newAudioCount: 0,
        newFileCount: 0,
        currentSendFileListLen: 0,
        loading: false,
        lastTextIndex: 0,
        videoPosterWidth: 276,
        videoPosterHeight: 276,
        canUploadType: [], //可上传类型，1图片，2视频，3文件，4语音
        audioList: [],
        imgUrlList: [],
        eleList: [],
        isCarryTitle:false,
      }
    },
    components: {

    },
    methods: {
      insertPartSimbol() {
        let tmp = this.content.split('');
        if (tmp[this.lastTextIndex - 1] && tmp[this.lastTextIndex - 1] == '\n' && tmp[this.lastTextIndex + 5] && tmp[
            this.lastTextIndex + 5] == '\n') {
          tmp.splice(this.lastTextIndex, 0, "<分段>")
        } else if (tmp[this.lastTextIndex - 1] && tmp[this.lastTextIndex - 1] == '\n' && tmp[this.lastTextIndex] !== '\n') {
          tmp.splice(this.lastTextIndex, 0, "<分段>\n")
        }else if (tmp[this.lastTextIndex - 1] && tmp[this.lastTextIndex - 1] == '\n'&& tmp[this.lastTextIndex] == '\n') {
          tmp.splice(this.lastTextIndex, 0, "<分段>")
        }else if (tmp[this.lastTextIndex + 5] && tmp[this.lastTextIndex + 5] == '\n') {
          tmp.splice(this.lastTextIndex, 0, "\n<分段>")
        } else if(tmp[this.lastTextIndex]=='\n'){
          tmp.splice(this.lastTextIndex, 0, "\n<分段>")
        } else {
          tmp.splice(this.lastTextIndex, 0, "\n<分段>\n")
        }
        this.content = tmp.join('');
      },
      onBlur() {
        console.log("onBlur...");
        this.lastTextIndex = this.getSelection();
      },
      getSelection() {
        let textarea = this.$refs['textarea'];

        // 获取文本域光标光标的开始位置和结束位置

        // 1. 位置定义：文本框中有文字的话，第一个文字的左边是0，右边是1，第二个文字的左边是1，右边是2
        // 2. 当页面刚加载完，文本域中有默认文字，那么selectionStart和selectionEnd都是相同的数值，都是最后一个位置，即有多少个文字，数值就是多少
        // 3. 如果是选中了文本，那么selectionStart就是被选中文字最左边开始的位置的数值（上面已说明），selectionEnd就是被选中文字最右边结束的位置的数值（上面已说明）
        // 4. 注意：当点击了文本域某个位置（或选择了一段文字），然后又失去焦点，仍然可以通过下面的方法获取到光标之前的位置
        // console.log(textarea.selectionStart,textarea.selectionEnd,'start,end');
        return textarea.selectionStart;
      },
      setSelection() {

        let textarea = this.$refs['textarea'];

        // 调用setSelectionRange方法去选中文本前，一定要先focus
        textarea.focus();
        // 将光标选中指定的文字，如果指定的selectionStart和selectionEnd相同，那就是选择固定的某个位置。如果不同，那就是选择一段文字。
        textarea.setSelectionRange(1, 2)
      },
      delClick(idx) {
        let file = this.fileList[idx];
        if (file) {
          let textLabel = ""
          if (file.fileType.includes("img")) {
            textLabel = "<图片" + (file.newImportIdx + 1) + ">"
          } else if (file.fileType.includes("video")) {
            textLabel = "<视频" + (file.newImportIdx + 1) + ">"
          } else if (file.fileType.includes("audio")) {
            textLabel = "<音频" + (file.newImportIdx + 1) + ">"
          } else {
            textLabel = "<文件" + (file.newImportIdx + 1) + ">"
          }
          let tmp = this.content.split(textLabel);
          this.content = tmp.join("")
        }
        this.fileList.splice(idx, 1)
      },
      changeFront(val) {
        this.isFront = val;
        localStorage.setItem("isFront", val)
      },
      backClick() {
        this.$router.go(-1);
      },
      replaceTag2Url() {
        this.fileList.forEach((file) => {
          let textLabel = ""
          if (file.fileType.includes("img")) {
            textLabel = "<图片" + (file.newImportIdx + 1) + ">"
          } else if (file.fileType.includes("video")) {
            textLabel = "<视频" + (file.newImportIdx + 1) + ">"
          } else if (file.fileType.includes("audio")) {
            textLabel = "<音频" + (file.newImportIdx + 1) + ">"
          } else {
            textLabel = "<文件" + (file.newImportIdx + 1) + ">"
          }
          let tmp = this.content.split(textLabel);
          // this.content=tmp.join("")
          this.content = file.fileType.includes("video") ? tmp[0] + file.qrPosterUrl + tmp[1] : tmp[0] + file.url +
            tmp[1];
        })
      },
      async savebtnClick() {
        // for(let i=0;i<this.fileList.length;i++){
        //     let file=this.fileList[i]
        //     if(file.fileType=="video"){
        //         file.posterFile=await this.generateVideoQr("video"+file.newImportIdx);
        //     }
        // }
        if (this.fileList.length) {
          await this.uploadFileList();
          await this.submitHuashuMapping();
          this.replaceTag2Url()
        }
        // if(!this.title.length){
        //     this.$message({
        //       message: '标题不能为空',
        //       type: 'warning'
        //     });
        //     return;
        // }
        if (!this.content.length) {
          this.$message({
            message: '内容不能为空',
            type: 'warning'
          });
          return;
        }

        let params = {
          speechId: this.speechId,
          labelId: this.labelId,
          speechText: this.content,
          editTime: new Date().getTime(),
          isCarryTitle: this.isCarryTitle?1:0,
          sortType: this.isFront,
        }
        if (this.title.length) {
          params.title = this.title;
        }
        if (this.huashuId) {
          params.id = this.huashuId;
        }
        console.log("huashuSave params=", params);
        let resp = await this.$http.huashuSave(params)
        console.log("huashuSave resp:", resp)
        if (resp.code === 200) {
          let result = resp.data.object;
          result.isFront = this.isFront;
          localStorage.setItem("updateHuashuItem", JSON.stringify(result))
          this.$router.go(-1);
        } else {
          this.$message({
            message: resp.message,
            type: 'warning'
          });
        }
      },
      addMediaBtnClick() {
        this.$refs.fileInput.click();
        // this.$alert('请使用微脉输入法App添加图片、视频和文件', '提示', {
        //   // confirmButtonText: '确定',
        //   showConfirmButton:false,
        //   callback: action => {

        //   }
        // });
      },
      getBaseURL(file) {
        var url = null;
        if (window.createObjectURL != undefined) { // basic
          url = window.createObjectURL(file)
        } else if (window.URL != undefined) { // mozilla(firefox)
          url = window.URL.createObjectURL(file)
        } else if (window.webkitURL != undefined) { // webkit or chrome
          url = window.webkitURL.createObjectURL(file)
        }
        return url;
      },
      generateVideoQr(domId) {
        return new Promise((resolve, reject) => {
          html2canvas(document.getElementById(domId), {
            useCORS: true,
          }).then((canvas) => {
            // document.body.appendChild(canvas);
            let dataUrl = this.convertCanvasToImage(canvas);
            let blob = this.dataURLtoBlob(dataUrl);
            let file = this.blobToFile(blob, domId);
            resolve(file)
          });
        })
      },
      getAudioInfo(file) {
        return new Promise((resolve, reject) => {
          let url = URL.createObjectURL(file); //获取录音时长
          const audioElement = document.createElement('audio')
          audioElement.setAttribute("preload", 'auto')
          audioElement.src = url
          audioElement.addEventListener("loadeddata", (_event) => {
            resolve({
              duration: audioElement.duration,
            })
          });
        })
      },
      getVideoInfo(file) {
        return new Promise((resolve, reject) => {
          let url = URL.createObjectURL(file); //获取录音时长
          const videoElement = document.createElement('video')
          videoElement.setAttribute("preload", 'auto')
          videoElement.src = url
          let duration;
          videoElement.addEventListener("loadeddata", (_event) => {
            const canvas = document.createElement('canvas')
            // canvas.width = this.videoPosterWidth * 0.2              
            // canvas.height = this.videoPosterHeight *0.2
            canvas.width = this.videoPosterWidth
            canvas.height = videoElement.videoHeight / videoElement.videoWidth * this.videoPosterHeight
            const ctx = canvas.getContext('2d')
            ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height)
            // const image = new Image()
            // canvas.toDataURL('image/png')即图片的base64              
            // image.src = canvas.toDataURL('image/png')
            //  // blob形式
            //  canvas.toBlob((blob) => {
            //      console.log(blob)             
            // }, 'image/png')
            resolve({
              duration: videoElement.duration,
              poster: canvas.toDataURL('image/png')
            })
          });
        })
      },
      /**
       * 二进制容器
       * @param {String} dataurl
       */
      getUint8Arr(dataurl) {
        // 截取base64的数据内容
        let arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          // 获取解码后的二进制数据的长度，用于后面创建二进制数据容器
          n = bstr.length,
          // 创建一个Uint8Array类型的数组以存放二进制数据
          u8arr = new Uint8Array(n)
        // 将二进制数据存入Uint8Array类型的数组中
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return {
          u8arr,
          mime
        }
      },
      /**
       * canvas转dataURL
       * @param {canvas} canvas
       */
      convertCanvasToImage(canvas) {
        // let image = new Image()
        // image.src = canvas.toDataURL('image/png')
        return canvas.toDataURL('image/png')
      },
      /**
       * dataURL转Blob对象
       * @param {String} dataurl
       */
      dataURLtoBlob(dataurl) {
        let uint8 = this.getUint8Arr(dataurl)
        return new Blob([uint8.u8arr], {
          type: uint8.mime
        })
      },
      /**
       * Blob转换为File
       * @param {Blob} theBlob
       * @param {String} fileName
       */
      blobToFile(theBlob, fileName) {
        theBlob.lastModifiedDate = new Date()
        theBlob.name = fileName
        return theBlob
      },
      async fileImport(e) {
        // if(this.currentSendFileListLen){
        //   this.$alert('请等待文件传输完成', '提示', {
        //     showConfirmButton:false,
        //     callback: action => {}
        //   });
        //   return
        // }
        let _this = this;
        let fileList = [];
        for (let idx = 0; idx < e.target.files.length; idx++) {
          let val = e.target.files[idx];
          //是否允许上传图片
          if (val.type.includes("image") && !this.canUploadType.find((val) => {
              return val == 1
            })) {
            this.$message.closeAll();
            this.$message({
              message: '图片上传已被限制',
              type: 'warning'
            });
            continue;
            return;
          }
          //是否允许上传视频
          if (val.type.includes("video") && !this.canUploadType.find((val) => {
              return val == 2
            })) {
            this.$message.closeAll();
            this.$message({
              message: '视频上传已被限制',
              type: 'warning'
            });
            continue;
            return;
          }
          //是否允许上传文件
          if ((!val.type.includes("image") && !val.type.includes("video")) && !this.canUploadType.find((val) => {
              return val == 3
            })) {
            this.$message.closeAll();
            this.$message({
              message: '文件上传已被限制',
              type: 'warning'
            });
            continue;
            return;
          }
          //是否允许上传音频
          if ((!val.type.includes("image") && !val.type.includes("audio")) && !this.canUploadType.find((val) => {
              return val == 4
            })) {
            this.$message.closeAll();
            this.$message({
              message: '音频上传已被限制',
              type: 'warning'
            });
            continue;
            return;
          }

          let fileExtension = val.name.split('.').pop().toLowerCase();
          if (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension ===
            'pdf' || fileExtension === 'doc' || fileExtension === 'docx' || fileExtension === 'dotm' ||
            fileExtension === 'dotx' || fileExtension === 'dotm' || fileExtension === 'txt' || fileExtension ===
            'xlsx' || fileExtension === 'xls' || fileExtension === 'mp4' || fileExtension === 'mov' ||
            fileExtension === 'mp3' || fileExtension === 'm4a' || fileExtension === 'aac' || fileExtension ===
            'caf' || fileExtension === 'ppt' || fileExtension === 'pptx') {
            let fileType;
            let newImportIdx;
            let videoInfo;
            let audioInfo;
            if (val.type.includes("image")) {
              fileType = "img";
              newImportIdx = this.newImgCount++;
            } else if (val.type.includes("video")) {
              fileType = "video";
              newImportIdx = this.newVideoCount++;
              videoInfo = await this.getVideoInfo(val);
            } else if (val.type.includes("audio")) {
              fileType = "audio";
              newImportIdx = this.newAudioCount++;
              audioInfo = await this.getAudioInfo(val);
            } else {
              fileType = "file";
              newImportIdx = this.newFileCount++;
            }
            let info = {
              file: val,
              path: this.getBaseURL(val),
              seq: idx,
              fileType: fileType,
              waitUpload: true,
              icon: this.getFileIcon(val.name),
              newImportIdx: newImportIdx,
              id: new Date().getTime() + idx
            }
            if (videoInfo) {
              info.videoInfo = videoInfo
            }
            if (audioInfo) {
              info.audioInfo = audioInfo
            }
            fileList.push(info)
          } else {
            this.$message({
              message: "不支持上传" + fileExtension + "类型文件",
              type: 'warning'
            });
          }
        }
        if (this.content.substring(this.lastTextIndex - 1, 2) != '\n') {
          let tmp = this.content.split("");
          tmp.splice(this.lastTextIndex, 0, "\n")
          this.content = tmp.join("");
          this.lastTextIndex += 1;
        }
        fileList.forEach((val, idx) => {
          this.$refs.textarea.focus();
          let tmp = this.content.split("");
          if (val.fileType.includes("img")) {
            tmp.splice(this.lastTextIndex + idx * 6, 0, "<图片" + (val.newImportIdx + 1) + ">\n")
          } else if (val.fileType.includes("video")) {
            tmp.splice(this.lastTextIndex + idx * 6, 0, "<视频" + (val.newImportIdx + 1) + ">\n")
          } else if (val.fileType.includes("audio")) {
            tmp.splice(this.lastTextIndex + idx * 6, 0, "<音频" + (val.newImportIdx + 1) + ">\n")
          } else {
            tmp.splice(this.lastTextIndex + idx * 6, 0, "<文件" + (val.newImportIdx + 1) + ">\n")
          }
          this.content = tmp.join("");
        });
        this.fileList.splice(this.fileList.length, 0, ...fileList)
        console.log("uploadFiles：", this.fileList);
      },
      async uploadFileList() {
        this.loading = this.$loading.service({
          lock: true,
          text: '上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          fullscreen: true
        });
        return new Promise(async (resolve, reject) => {
          if (!this.fileList.length) {
            resolve(false)
            return;
          }

          let partArr = this.fileList.filter((val) => {
            return !val.waitUpload;
          })
          let waitUploadFileArr = this.fileList.filter((val) => {
            return val.waitUpload;
          })
          console.log('waitUploadFileArr.length==' + waitUploadFileArr.length);
          if (waitUploadFileArr.length) {
            let waitUploadImgList = waitUploadFileArr.filter((file) => {
              return file.fileType == 'img'
            })
            let waitUploadVideoList = waitUploadFileArr.filter((file) => {
              return file.fileType == 'video'
            })
            let waitUploadOtherList = waitUploadFileArr.filter((file) => {
              return file.fileType == 'file' || file.fileType == 'audio'
            })
            let tokenParams = {
              functionType: 2,
              targetId: localStorage.getItem("edujia:group:web:userid")
            }
            let imageSuffix = [];
            waitUploadFileArr.forEach((file) => {
              if (file.fileType == 'img') {
                // imageSuffix.push(file.file.type)
                imageSuffix.push(file.file.type.split("/")[1])
              }
            })
            if (imageSuffix.length) {
              tokenParams.imageSuffix = JSON.stringify(imageSuffix)
            }

            let videoSuffix = [];
            waitUploadFileArr.forEach((file) => {
              if (file.fileType == 'video') {
                videoSuffix.push(file.file.type.split("/")[1])
              }
            })
            if (videoSuffix.length) {
              tokenParams.videoSuffix = JSON.stringify(videoSuffix)
            }
            let mediaSuffix = [];
            waitUploadFileArr.forEach((file) => {
              if (file.fileType != 'video' && file.fileType != 'img') {
                mediaSuffix.push(file.file.name.split(".")[1])
              }
            })
            if (mediaSuffix.length) {
              tokenParams.mediaSuffix = JSON.stringify(mediaSuffix)
            }
            console.log("tokenParams:", tokenParams);
            let enResp = await this.$http.getFileUploadToken(tokenParams);
            if (enResp.code == 200) {
              let data = JSON.parse(this.$common.decrypt(enResp.data, localStorage.getItem(
                "edujia:group:web:key")))
              console.log("getFileUploadToken res:", data);
              let imageDomain = data.object.imageDomain;
              let videoDomain = data.object.videoDomain;
              let mediaDomain = data.object.mediaDomain;
              if (waitUploadImgList.length) {
                let resultArr = await qiniuService.uploadImgArr(data.object.imageToken, waitUploadImgList);
                console.log('result ==' + JSON.stringify(resultArr));
                resultArr.forEach((val, index) => {
                  this.fileList.forEach((file) => {
                    if (file.id == val.id) {
                      file.key = val.url.key;
                      file.url = imageDomain + val.url.key;
                    }
                  })
                })
              }
              if (waitUploadVideoList.length) {
                for (let i = 0; i < waitUploadVideoList.length; i++) {
                  let waitUploadVideo = waitUploadVideoList[i];
                  let uploadResult = await qiniuService.uploadVideo(waitUploadVideo.file, data.object
                    .videoToken[i])
                  waitUploadVideo.videoUrl = videoDomain + uploadResult.key
                  new QRCode("videoQr" + waitUploadVideo.newImportIdx, {
                    text: waitUploadVideo.videoUrl, // 需要转换为二维码的内容
                    width: 76,
                    height: 76,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                  })
                  waitUploadVideo.posterFile = await this.generateVideoQr("video" + waitUploadVideo
                    .newImportIdx);
                }
                let resultArr = await qiniuService.uploadHuashuVideoArr(data.object.videoToken,
                  waitUploadVideoList);
                console.log('result ==' + JSON.stringify(resultArr));
                resultArr.forEach((val, index) => {
                  this.fileList.forEach((file) => {
                    if (file.id == val.id) {
                      file.key = val.url.key;
                      file.url = videoDomain + val.url.key;
                      file.icon = this.$common.getVideoPoster(file.url);
                      file.qrPosterUrlKey = val.qrPosterUrl.key;
                      file.qrPosterUrl = imageDomain + val.qrPosterUrl.key;
                    }
                  })
                })
              }
              if (waitUploadOtherList.length) {
                let resultArr = await qiniuService.uploadImgArr(data.object.mediaToken, waitUploadOtherList);
                console.log('result ==' + JSON.stringify(resultArr));
                resultArr.map((val, index) => {
                  this.fileList.forEach((file) => {
                    if (file.id == val.id) {
                      file.key = val.url.key;
                      file.url = mediaDomain + val.url.key;
                      // if(file.fileType=='video'){
                      //   file.icon=this.$common.getVideoPoster(file.url);
                      // }
                    }
                  })
                })
              }
            }
          }
          console.log("uploaded fileList:", this.fileList);
          this.loading.close()
          resolve()
        })
      },
      //查询话术可添加的文件类型
      async qryHuashuLimit() {
        let params = {
          speechId: this.speechId,
          labelId: this.labelId,
          id: this.huashuId ? this.huashuId : 0,
        }
        let enResp = await this.$http.qryHuashuLimit(params);
        if (enResp.code == 200) {
          //可上传类型，1图片，2视频，3文件，4语音
          this.canUploadType = enResp.data.object.canUploadType;
          // this.canUploadType=[2,4]
        }
      },
      //话术多媒体 提交映射
      async submitHuashuMapping() {
        return new Promise(async (resolve, reject) => {
          let mediaArray = this.fileList.map((file) => {
            let type;
            if (file.fileType == "img") {
              type = 1;
            } else if (file.fileType == "video") {
              type = 2;
            } else {
              type = 3;
            }
            let info = {
              url: file.url,
              type: type,
            }
            if (type == 2) {
              info.imageUrl = file.qrPosterUrl;
            }
            if (type == 3) {
              info.title = file.file.name;
            }
            return info
          })
          let params = {
            mediaArray: JSON.stringify(mediaArray),
          }
          let enResp = await this.$http.submitHuashuMapping(params);
          if (enResp.code == 200) {
            resolve();
          }
        })
      },
      replaceAll(string, search, replace) {
        return string.split(search).join(replace);
      },
      getFileIcon(fileName) {
        let icon = ""
        if (fileName.includes(".doc")) {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143256.png"
        } else if (fileName.includes(".txt")) {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143245.png"
        } else if (fileName.includes(".xls")) {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143214.png"
        } else if (fileName.includes(".mp3") || fileName.includes(".m4a")) {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114041.png"
        } else if (fileName.includes(".pdf")) {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114100.png"
        } else if (fileName.includes(".ppt") || fileName.includes(".pptx")) {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230608114321.png"
        } else {
          icon = "https://imagessl.edujia.com/A-1ed71af7_20230601152642.png"
        }
        return icon;
      },
      // 提取文件后缀的辅助函数
      getFileExtension(url) {
        const path = url.split('/');
        const fileName = path[path.length - 1];
        const parts = fileName.split('.');

        if (parts.length > 1) {
          return parts.pop();
        }

        return '';
      },
      generateEleList(text) {
        let eleList = []
        let _this = this;
        // this.huashuList.forEach((huashu)=>{
        text = this.replaceAll(text, "<分段>", "");
        // text=this.replaceAll(text,"\n"," *** ");

        // const urlRegex = /https?:\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/gi;
        const urlRegex =
          /https?:\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]\.(png|jpg|jpeg|pdf|docx|doc|dotm|xlsx|xls|mp4|mov|mp3|m4a|aac|caf|pptx|ppt|txt)/gi;
        const urls = [];
        let match;
        let lastPart = text;

        while ((match = urlRegex.exec(text)) !== null) {
          let url = match[0];
          const fileExtension = this.getFileExtension(url);

          // 只添加具有正确文件后缀的URL
          if (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension ===
            'pdf' || fileExtension === 'doc' || fileExtension === 'docx' || fileExtension === 'dotm' ||
            fileExtension === 'dotx' || fileExtension === 'dotm' || fileExtension === 'txt' || fileExtension ===
            'xlsx' || fileExtension === 'xls' || fileExtension === 'mp4' || fileExtension === 'mov' || fileExtension ===
            'mp3' || fileExtension === 'm4a' || fileExtension === 'aac' || fileExtension === 'caf' || fileExtension ===
            'ppt' || fileExtension === 'pptx') {
            let tmp = lastPart.split(url);
            // console.log("tmp==",tmp[0]);
            eleList.push({
              type: "text",
              val: tmp[0],
            })
            if (fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
              eleList.push({
                type: "img",
                val: url,
              })
              this.imgUrlList.push(url)
            } else if (fileExtension === 'mp4') {
              eleList.push({
                type: "video",
                val: url,
              })
            } else if (fileExtension === 'mp3' || fileExtension === 'm4a') {
              let eleIdx = eleList.length;
              let tmpUrl = new URL(url);
              let fileName = tmpUrl.pathname.split('/').pop();
              let audio = new Audio();
              audio.src = url;
              audio.id = "audio" + eleIdx;
              let id = new Date().getTime();
              eleList.push({
                type: "audio",
                val: url,
                fileName: fileName,
                fileIcon: this.getFileIcon(fileName),
                id: id
              })
              audio.muted = true;
              audio.play().then(() => {
                audio.pause()
              })
              audio.muted = false;
              audio.addEventListener("loadedmetadata", () => {
                console.log("audio duration==", audio.duration);
                this.eleList.forEach((ele, idx) => {
                  if (ele.id == id) {
                    this.eleList.splice(idx, 1, {
                      type: "audio",
                      val: url,
                      fileName: fileName,
                      fileIcon: this.getFileIcon(fileName),
                      duration: audio.duration * 1000,
                    });
                  }
                })
              });
              this.audioList.push(audio)
            } else {
              let tmpUrl = new URL(url);
              const fileName = tmpUrl.pathname.split('/').pop();
              eleList.push({
                type: "file",
                val: url,
                fileName: fileName,
                fileIcon: this.getFileIcon(fileName)
              })
            }
            // lastPart=tmp[1]
            let str = ""
            tmp.forEach((tmpItem, idx) => {
              if (idx) {
                str += tmpItem
              }
            })
            lastPart = str;
          }
        }
        eleList.push({
          type: "text",
          val: lastPart,
        })
        console.log(eleList);
        // })
        return eleList;
      },
    },
    mounted() {
      this.contentHeight = this.pageHeight - 79 - 40 - 10;
      window.addEventListener('resize', () => {
        this.pageWidth = document.documentElement.clientWidth;
        this.pageHeight = document.documentElement.clientHeight;
        this.contentHeight = this.pageHeight - 79 - 40 - 10;
      });
      this.qryHuashuLimit();
    },
    created() {
      console.log("huashuEdit created...");
      if (localStorage.getItem("editHuashuData")) {
        this.editHuashuData = JSON.parse(localStorage.getItem("editHuashuData"));
        this.title = this.editHuashuData.title;
        this.content = this.editHuashuData.speechText;
        this.isCarryTitle = this.editHuashuData.isCarryTitle;
        let eleList = this.generateEleList(this.content);
        let fileList = [];
        let imgCount = 0;
        let fileCount = 0;
        let audioCount = 0;
        let videoCount = 0;
        eleList.forEach((ele) => {
          if (ele.type != 'text') {
            let file = {
              waitUpload: false,
            };
            if (ele.type == "img" && ele.val.includes("video.")) {
              file.newImportIdx = videoCount;
              videoCount++;
              file.fileType = "video"
              file.url = ele.val;
              file.qrPosterUrl = ele.val;
              file.videoInfo = {
                duration: 0,
                poster: ele.val
              }
              file.file = {
                type: "video"
              };
              // file.fileType="video";
              // file.newImportIdx=videoCount;
              // videoCount++;
              // file.qrPosterUrl=ele.val;
              // file.videoInfo={
              //     poster:ele.val,
              //     duration:0,
              // }
              // file.file={
              //     type:"video"
              // };
              let tmp = this.content.split(ele.val)
              this.content = tmp[0] + "<视频" + videoCount + ">" + tmp[1]
            } else {
              file.fileType = ele.type
              file.url = ele.val;
              if (ele.type == "file") {
                file.newImportIdx = fileCount;
                fileCount++;
                file.icon = ele.fileIcon;
                file.name = ele.fileName;
                file.file = {
                  type: ""
                };
                // let tmp=this.content.split(ele.val)
                // this.content=tmp[0]+"<文件"+fileCount+">"+tmp.splice(0,1).join("")
                this.content = this.content.replace(ele.val, "<文件" + fileCount + ">");
              } else if (ele.type == "audio") {
                file.newImportIdx = audioCount;
                audioCount++;
                file.icon = ele.fileIcon;
                file.name = ele.fileName;
                file.file = {
                  type: ""
                };
                this.content = this.content.replace(ele.val, "<音频" + audioCount + ">");
              } else {
                file.newImportIdx = imgCount;
                imgCount++;
                file.file = {
                  type: "image"
                };
                let tmp = this.content.split(ele.val)
                this.content = tmp[0] + "<图片" + imgCount + ">" + tmp[1]
              }
            }
            fileList.push(file)
          }
        })
        this.fileList = fileList;
        this.huashuId = this.editHuashuData.id;
        let imgList = this.fileList.filter((file) => {
          return file.fileType == "img"
        })
        let videoList = this.fileList.filter((file) => {
          return file.fileType == "video"
        })
        let audioList = this.fileList.filter((file) => {
          return file.fileType == "audio"
        })
        let otherList = this.fileList.filter((file) => {
          return file.fileType != "img" && file.fileType != "video"
        })
        this.newImgCount = imgList.length;
        this.newVideoCount = videoList.length;
        this.newAudioCount = audioList.length;
        this.newFileCount = otherList.length;
      }
    },
  }
</script>

<style scoped>
  .top {
    width: 100%;
    min-width: 200px;
    height: 52px;
    color: #4a90e2;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 25px;
    position: fixed;
    left: 0;
    top: 32px;
    background-color: #fff;
    justify-content: space-between;
  }

  .top img {
    width: 20px;
    height: 20px;
    margin-left: 14px;
    margin-right: 4px;
  }

  .topL {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 25px;
  }

  .title {
    border: 0;
    padding: 0;
    outline: none;
    padding-bottom: 4px;
    width: 94.87%;
    height: 22px;
    margin-left: 2.56%;
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    padding-top: 84px;
  }

  .content {
    padding: 0;
    padding-top: 4px;
    padding-left: 8px;
    padding-right: 8px;
    width: calc(94.87vw - 16px);
    margin-left: 2.56%;
    margin-top: 8px;
    font-size: 14px;
    line-height: 20px;
    color: #3c3c3c;
    height: 164px;
    border: 1px solid #E5E5E5;
    border-radius: 4px;
  }

  .bottomBar {
    background-color: #fff;
    width: 100%;
  }

  .bottomBarL {
    display: flex;
    align-items: center;
    min-width: 250px;
  }

  .bottomBarLNone {}

  .bottomBarR {
    display: flex;
    align-items: center;
    margin-left: 2.56%;
    min-width: 240px;
  }

  .addLink {
    display: flex;
    align-items: center;
    color: #4A90E2;
    font-size: 14px;
    margin-right: 12px;
  }

  .addLink img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }

  .saveBtn {
    width: 91px;
    height: 27px;
    background-color: #FB5D5C;
    color: #fff;
    font-size: 10px;
    line-height: 14px;
    font-weight: 500;
    border-radius: 4px;
    margin-right: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .optionTitle {
    padding-left: 2.56%;
    padding-right: 16px;
    color: #3C3C3C;
    font-size: 14px;
    line-height: 40px;
    height: 40px;
  }

  .optionItem {
    display: flex;
    align-items: center;
    margin-right: 12px;
  }

  .optionItem2 {
    display: flex;
    align-items: center;
    margin-right: 0px;
  }

  .optionItem img {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }

  .optionItem div {
    font-size: 14px;
    font-weight: 400;
    color: #3C3C3C;
  }

  .list {
    display: flex;
    width: calc(94.87vw - 2.56vw);
    margin-left: 2.56%;
    flex-wrap: wrap;
    padding-bottom: 50px;
    padding-top: 4px;
  }

  .itemP {
    margin: 0 10px 10px 10px;
    position: relative;
  }

  .itemClose {
    width: 14px;
    height: 14px;
    position: absolute;
    right: 4px;
    top: 4px;
    z-index: 9999;
  }

  .item {
    width: 100px;
    height: 100px;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
  }

  .imgItem {
    object-fit: cover;
    display: block;
  }

  .fileItem {
    object-fit: cover;
    background-color: #F5F6F6;
  }

  .fileItem img {
    width: 48px;
    height: 48px;
    margin: auto;
    padding-top: 14px;
    display: block;
  }

  .fileItem div {
    width: 98px;
    height: 32px;
    margin-left: 4px;
    margin-top: 11px;
    overflow: hidden;
    font-size: 11px;
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
    word-break: break-all;
  }

  .videoItem {}

  .videoItem img {
    width: 110px;
    height: 110px;
    object-fit: cover;
  }

  .videoItemVideo {
    width: 276px;
    height: 276px;
    overflow: hidden;
    margin: 24px 32px 24px 32px;
  }

  .videoItemVideo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .videoPosterT {
    position: relative;
  }

  .videoPosterB {
    display: flex;
  }

  .videoPosterBL {
    width: 76px;
    height: 76px;
    margin-left: 52px;
  }

  .videoPosterBR {
    margin-left: 16px;
  }

  .videoPosterBRT {
    font-size: 24px;
    color: #3C3C3C;
    line-height: 33px;
  }

  .videoPosterBRB {
    margin-top: 4px;
    font-size: 20px;
    line-height: 28px;
    color: #999999;
  }

  .videoPoster {
    width: 340px !important;
    height: 418px !important;
    background-color: #fff;
    position: absolute;
    left: -9999px;
    top: -9999px;
  }

  .videoIcon {
    width: 88px !important;
    height: 88px !important;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -44px;
    margin-top: -44px;
  }

  .miniVideoIcon {
    width: 24px !important;
    height: 24px !important;
    margin-left: -12px;
    margin-top: -12px;
  }

  .fileLabel {
    font-size: 12px;
    color: #3C3C3C;
    text-align: center;
    margin-top: 4px;
  }
</style>